import { Box } from "@outschool/backpack";
import { Container, Modal } from "@outschool/ui-legacy-component-library";
import React from "react";

import ActivityEnrollableTimes from "../activityEnrollableTimes/ActivityEnrollableTimes";
import { AvailableTimesWrapper } from "../availableTimes/AvailableTimesWrapper";
import ActivityDetailDescription from "../sections/ActivityDetailDescription";
import LearningGoals from "../sections/LearningGoals";
import OtherDetails from "../sections/OtherDetails";
import { ReviewsSection } from "../sections/Reviews";
import SyllabusSummary from "../sections/SyllabusSummary";
import TeacherSection from "../sections/TeacherSection";
import WhatsIncluded from "../sections/WhatsIncluded";
import ClassDetailsNav from "../subcomponents/ClassDetailsNav";
import MobileActivityHeader from "../subcomponents/MobileActivityHeader";
import { MobileContainerProps } from "./ClassDetailsMainBody";

export default function MobileContainer({
  activity,
  activityWithEnrollableTimes,
  classNavTabs,
  hasOneOnOneAvailabilities,
  isAvailabilityModalOpen,
  isLoadingOneOnOneAvailabilities,
  isOrganizationEnrollment,
  leader,
  onClickMoreLikeThis,
  onClickViewReviews,
  onEnrollClick,
  refsContainer,
  sectionsRef,
  setIsAvailabilityModalOpen,
  setTabValue,
  showAvailableTimes,
  tabValue
}: MobileContainerProps) {
  return (
    <>
      <Box
        ref={refsContainer.about.header}
        flex
        sx={{ flexDirection: "column" }}
      >
        <MobileActivityHeader
          activity={activity}
          leader={leader}
          onClickViewReviews={onClickViewReviews}
        />
      </Box>
      {showAvailableTimes && (
        <Container ref={sectionsRef} sx={{ marginTop: "2em" }}>
          <AvailableTimesWrapper
            activity={activity}
            isOrganizationEnrollment={isOrganizationEnrollment}
            onClickMoreLikeThis={onClickMoreLikeThis}
          />
        </Container>
      )}
      <Modal
        stickyHeader
        open={!!isAvailabilityModalOpen}
        onClose={() =>
          !!setIsAvailabilityModalOpen && setIsAvailabilityModalOpen(false)
        }
        sx={{ padding: "1.25em" }}
      >
        {((hasOneOnOneAvailabilities ||
          (activity.hasTeacherSchedule && isLoadingOneOnOneAvailabilities)) &&
          activity.canEnroll &&
          activityWithEnrollableTimes && (
            <ActivityEnrollableTimes
              activity={activityWithEnrollableTimes}
              leader={leader}
              onEnrollClick={onEnrollClick}
            />
          )) || (
          <AvailableTimesWrapper
            activity={activity}
            isOrganizationEnrollment={isOrganizationEnrollment}
            onClickMoreLikeThis={onClickMoreLikeThis}
          />
        )}
      </Modal>
      <ClassDetailsNav tabs={classNavTabs ?? []} />
      <Box
        flex
        sx={{
          marginTop: "6.4rem",
          flexDirection: "column",
          gap: "8rem",
          marginX: 16
        }}
      >
        <WhatsIncluded
          activity={activity}
          headerRef={refsContainer.about.whatsIncluded}
        />
        <ActivityDetailDescription
          activity={activity}
          headerRef={refsContainer.about.classExperience}
        />
        <LearningGoals
          learningGoals={activity.learningGoals}
          headerRef={refsContainer.learningOverview.learningGoals}
        />
        <SyllabusSummary
          activity={activity}
          headerRef={refsContainer.learningOverview.syllabus}
        />
        <OtherDetails
          activity={activity}
          headerRef={refsContainer.learningOverview.otherDetails}
        />
        <TeacherSection
          activity={activity}
          leader={leader}
          onClickViewReviews={onClickViewReviews}
          teacherHeaderRef={refsContainer.teacher.header}
          credentialsRef={refsContainer.teacher.expertise}
        />
        {!!tabValue && !!setTabValue && (
          <ReviewsSection
            activity={activity}
            reviewsRef={refsContainer.reviews}
            setTabValue={setTabValue}
            tabValue={tabValue}
          />
        )}
      </Box>
    </>
  );
}
